<template>
    <b-card no-body>
        <b-card-header class="title-display">
            <div class="title-one">
                {{ applicationTitle }}
            </div>
            <div class="title-two">
                {{ applicationDisclaimer }}
            </div>
        </b-card-header>
        <b-card-body>
            <div>
                <span class="title-three">{{ applicationDateRange }}</span>
            </div>
            <div>
                <span class="title-four">FAIN:&nbsp;{{ applicationFain }}</span>
            </div>
            <div>
                <span class="title-four">
                    Total federal award to Arkansas:&nbsp;
                    <strong>${{ awardedToState.toLocaleString('en') }}</strong>
                </span>
            </div>
            <div>
                <span class="title-four">
                    Amount awarded to {{ applicantName }}:&nbsp;
                    <strong>${{ awardedToApplicant.toLocaleString('en') }}</strong>
                </span>
            </div>
        </b-card-body>
    </b-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Info',

    computed: {
        ...mapGetters({
            // coverPageInfo: 'ref/coverpage/coverPageInfo',
            generalInformation: 'coverpage/generalInformation'
        }),


        applicationTitle() {
            return this.generalInformation.application_title;
        },

        applicationDisclaimer() {
            return this.generalInformation.application_disclaimer;
        },

        applicationDateRange() {
            return this.generalInformation.application_date_range;
        },

        applicationFain() {
            return this.generalInformation.fain;
        },

        awardedToState() {
            return this.generalInformation.federal_award_to_state;
        },

        awardedToApplicant() {
            return this.generalInformation.state_award_to_applicant;
        },

        applicantName() {
            return this.generalInformation.applicant_name;
        }
    }
};
</script>
